import { Component, Input } from '@angular/core';
import { isArray, isObject, isString } from 'lodash';
import { IWizardContentComponent } from '../../../wizard.content';

@Component({
  selector: 'syslog-results',
  templateUrl: './syslog.results.template.html',
  styleUrls: ['../syslog.configuration.style.scss']
})
export class SyslogResultsComponent implements IWizardContentComponent {
  @Input() step: any; //eslint-disable-line
  @Input() subStep: any; //eslint-disable-line
  @Input() wizardCtrl: any; //eslint-disable-line
  @Input() id: string;
  @Input() previousOutput: any; //eslint-disable-line

  constructor() {} //eslint-disable-line

  requestFailed(): boolean {
    return this.wizardCtrl.getWizardService().requestFailed;
  }

  get errorMessage(): string {
    // Backend has too many different formats to return error message
    // Here is support for all of them
    const msg = this.wizardCtrl.getWizardService().errorMessage;
    if (isString(msg)) {
      return msg;
    } else if (isArray(msg)) {
      return msg.join(', ');
    } else if (isObject(msg)) {
      const list = [];

      for (const key in msg) {
        //eslint-disable-next-line
        if (msg.hasOwnProperty(key)) {
          const element = msg[key];
          list.push(`${key}: '${element}'`);
        }
      }

      return list.join(', ');
    } else {
      return 'Something unexpected happend!';
    }
  }

  get errorDescription(): string {
    if (
      this.wizardCtrl.getWizardService().errorDescription ===
      this.wizardCtrl.getWizardService().errorMessage
    ) {
      return null;
    }

    return this.wizardCtrl.getWizardService().errorDescription;
  }

  get successMessage(): string {
    return this.wizardCtrl.getWizardService().successMessage;
  }
}
